module.exports = __webpack_public_path__ + "img/Trinidad & Tobago.b4214bc9.svg";